import { When } from 'react-if';
// eslint-disable-next-line import/named
import { Box, SvgIconOwnProps } from '@mui/material';
// eslint-disable-next-line import/named
import { SxProps } from '@mui/material/styles';

import { theme } from '@components/mui/ThemeProvider';
import { Text } from '@nerdwallet/currency/components/Text';

import LockIcon from '@components/icons/lock-icon';

const defaultContainerStyle: SxProps = {
  alignItems: 'center',
  borderRadius: '24px',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 3,
  backgroundColor: theme.palette.yellow.lighter2,
  paddingX: '8px',
  paddingY: '6px',
  gap: '4px',
};

interface Props {
  containerStyle?: SxProps;
  iconStyle?: SvgIconOwnProps;
  labelText?: string;
}

const LockLabel: React.FC<Props> = ({
  containerStyle = {},
  iconStyle = {},
  labelText,
}) => (
  <Box sx={{ ...defaultContainerStyle, ...containerStyle }}>
    <LockIcon {...iconStyle} />
    <When condition={labelText}>
      <Text size="small" bold>
        {labelText}
      </Text>
    </When>
  </Box>
);

export default LockLabel;
